import React from "react";
import { Grid, makeStyles } from "@material-ui/core";
import Page from "../components/Page";
import PasswordContainer from "../containers/profile/PasswordContainer";
import EditProfileContainer from "../containers/profile/EditProfileContainer";
import ProfileForm from "../forms/account/ProfileForm";
import AddressForm from "../forms/account/AddressForm";

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.default,
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3),
    marginBottom: theme.spacing(7),
    marginLeft: theme.spacing(3),
  },
}));

const AccountPage = () => {
  const classes = useStyles();

  return (
    <Page className={classes.root} title="Ecat">
      <Grid container spacing={3}>
        <Grid item xs={12} sm={6}>
          <EditProfileContainer>
            {(props) => (
              <ProfileForm
                initialValues={props.content}
                onSubmit={props.onSubmit}
              />
            )}
          </EditProfileContainer>
        </Grid>
        <Grid item xs={12} sm={6}>
          <PasswordContainer />
        </Grid>
        <Grid item xs={12} sm={6}>
          <EditProfileContainer>
            {(props) => (
              <AddressForm
                initialValues={props.content.profile}
                onSubmit={props.onSubmit}
              />
            )}
          </EditProfileContainer>
        </Grid>
      </Grid>
    </Page>
  );
};

export default AccountPage;
